import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { track } from '../utils/analytics';

const AgeGate = ({ onVerified }) => {
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const verified = localStorage.getItem('nobelly_age_verified');
    if (verified === 'true') {
      setIsVerified(true);
      onVerified();
    }
  }, [onVerified]);

  const handleYes = () => {
    localStorage.setItem('nobelly_age_verified', 'true');
    track('age_gate_completed');
    setIsVerified(true);
    onVerified();
  };

  const handleNo = () => {
    // Age gate refusal is not part of the required event list, so we do
    // not push an analytics event here.
    window.location.href = 'https://www.google.com';
  };

  if (isVerified) return null;

  return (
    <div className="age-gate-overlay">
      <div className="age-gate-container">
        <div className="age-gate-logo">
          <img 
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_044e7215-b684-4e8a-bc75-b8b1576b06e1/artifacts/tue77akt_Logo.webp" 
            alt="Hopfenzauber No-Belly Bier Logo" 
            className="logo-image"
          />
        </div>
        
        <div className="age-gate-content">
          <div className="warning-icon">
            <AlertTriangle size={60} color="#FFD700" strokeWidth={2} />
          </div>
          
          <h1 className="age-gate-title">AGE VERIFICATION REQUIRED</h1>
          
          <div className="age-gate-warnings">
            <p className="warning-text primary">ENTER ONLY IF YOU ARE 21 YEARS OR OLDER</p>
            <p className="warning-text">CONSUMPTION OF ALCOHOL IS INJURIOUS TO HEALTH</p>
            <p className="warning-text">BE SAFE DON'T DRINK AND DRIVE</p>
            <p className="warning-text">NOT TO BE CONSUMED BY PREGNANT WOMEN OR BREASTFEEDING MOTHERS</p>
            <p className="warning-text">SALE PROHIBITED TO PERSONS BELOW 21 YEARS</p>
            <p className="warning-text">ALCOHOL CONSUMPTION DURING PREGNANCY CAN BE HARMFUL TO THE UNBORN BABY</p>
            <p className="warning-text">DRINK RESPONSIBLY</p>
          </div>

          <p className="age-gate-question">Are you 21 years of age or older?</p>

          <div className="age-gate-buttons">
            <button onClick={handleYes} className="btn-age-yes" data-testid="age-gate-yes-btn">
              YES, I AM 21+
            </button>
            <button onClick={handleNo} className="btn-age-no" data-testid="age-gate-no-btn">
              NO, I AM NOT
            </button>
          </div>

          <p className="age-gate-footer">
            By entering this site, you agree to our terms of use and privacy policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
